module.exports = __webpack_public_path__ + "img/YourLabSetup.4d42714b.png";